<template>
	<div class="lang-select-container mt-5">
		<v-select dense outlined rounded :items="languages" @change="onSelect" :value="selected"/>
	</div>
</template>

<script>

export default {
	name: "lang-select",
	props: {value: {}},
	components: {},
	data() {
		return {
			languages: [
				{text: "עברית", flag: "flag-icon-il", value: "he"},
				{text: "English", flag: "flag-icon-us", value: "en"},
				{text: "عربيه", flag: "flag-icon-us", value: "ar"}
			],
			selected:"he"
		};
	},
	computed: {
		// selected: {
		// 	get() {
		// 		return this.$i18n.locale;
		// 	},
		// 	set(lang) {
		// 		this.$i18n.locale = lang;
		// 		localStorage.setItem("lang", lang);
		// 		this.$vuetify.rtl = this.$i18n.locale == 'he';
		// 		this.reloadPageWithParameter('lang='+lang);
		//
		// 	}
		// }
	},
	methods: {
		onSelect(lang){
					localStorage.setItem("lang", lang);
					this.$vuetify.rtl = this.$i18n.locale == 'he';
					this.reloadPageWithParameter("lang",lang);
		},
// Function to reload the page with a new parameter in the query string
		reloadPageWithParameter(key, value) {
			// Get the current URL
			const currentUrl = new URL(window.location.href);

			// Get the existing search parameters
			const existingSearchParams = new URLSearchParams(currentUrl.search);

			// Append or update the parameters from the queryParams object
				existingSearchParams.set(key, value);

			// Update the search parameters in the URL
			currentUrl.search = existingSearchParams.toString();

			// Set the modified URL to window.location.href to reload the page
			window.location.href = currentUrl.toString();
		}

// Example usage: Reload the page with a new parameter "key=value"

	},
	created() {
		let lang = document.querySelector("html").getAttribute('lang') || navigator.language || "he";
		if (lang) {
			this.selected = lang;
		}
	}
};
</script>

<style scoped>
.lang-select-container {
	max-width: 150px;
	margin-right: auto;
	margin-left: auto;
}
</style>
